export const AUTH_TOKEN = "AUTH-TOKEN";
export const REFRESH_AUTH_TOKEN = "REFRESH-AUTH-TOKEN";

export const BASE_URL_PROD = "https://visit.criss.com.cn";

export const HTTP_STATUS: { [key: string]: number } = {
  SUCCESS: 200,
  CREATED: 201,
  ACCEPTED: 202,
  CLIENT_ERROR: 400,
  AUTHENTICATE: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};
